export default "__VITE_ASSET__Bx9RZ81v__"